<app-navbar></app-navbar>
<div class="container" style="text-align: center;">
  <h1 style="color: white;">Videos</h1>

  <div class="video-container" style='margin-top: 15px; margin-bottom: 15px;'>
    <div class="youtube-embed">
      <iframe width="420" height="315" src="https://www.youtube.com/embed/0cLn-EqE_Ag" frameborder="0"
        allowfullscreen=""></iframe>
    </div>
  </div>
</div>
<!-- 
<div class="container" style="text-align: center;">
  <h1>Videos</h1>

  <div class="video-container">
    <video class="video" controls>
      <div class="youtube-embed">
        <iframe width="420" height="315" src="https://www.youtube.com/embed/0cLn-EqE_Ag" frameborder="0"
          allowfullscreen=""></iframe>
      </div>
    </video>
    <video class="video" controls>
      <div class="youtube-embed">
        <iframe width="420" height="315" src="https://www.youtube.com/embed/0cLn-EqE_Ag" frameborder="0"
          allowfullscreen=""></iframe>
      </div>
    </video>
    <video class="video" controls>
      <div class="youtube-embed">
        <iframe width="420" height="315" src="https://www.youtube.com/embed/0cLn-EqE_Ag" frameborder="0"
          allowfullscreen=""></iframe>
      </div>
    </video>
    <video class="video" controls>
      <div class="youtube-embed">
        <iframe width="420" height="315" src="https://www.youtube.com/embed/0cLn-EqE_Ag" frameborder="0"
          allowfullscreen=""></iframe>
      </div>
    </video>
  </div>
</div> -->